require('./contractPayrollLoanDocumentsButtons.scss');
const PropTypes = require('prop-types');
// @ vendor
const React = require('react');
const { formatText } = require('core/i18n').i18n;
// @components
const { OKButton } = require('components/commons/OKButton/OKButton');
const PrinterPreviewManagerButton = require('components/contactCenter/printer/printerPreviewManagerButton');


// @constants
const { payrollLoanRecordStatus: { requestStatus: { ERROR_DOCUMENTACION } } } = require('../../../../loansConstants/index');
const ContactCenterRender = require('components/conditionalRender/contactCenterRender');
const WebappRender = require('components/conditionalRender/webappRender');

//@utilities
const { isPrintOfficeMode } = require('utilities/contactCenter/printerHelper');

class ContractPayrollLoanDocumentsButtons extends React.Component {
    buildFinishBtn() {
        const { finishButtonDisabled, handleFinishBtn, loading, recordStatus } = this.props;
        let buttonText = formatText("payrollLoanRequestStepThree-ctaButton");

        if (recordStatus === ERROR_DOCUMENTACION) {
            buttonText = formatText("payrollLoanRequestStepThree-docErrorButton");
        }

        const props = {
            disabled: finishButtonDisabled,
            modifier: 'primary',
            onClick: handleFinishBtn,
            loading: loading
        }

        let buttonComponent;

        if (__CONTACT_CENTER__ && !isPrintOfficeMode()) {
            buttonComponent = (
                <PrinterPreviewManagerButton {...props}>
                    {buttonText}
                </PrinterPreviewManagerButton>
            );
        } else {
            buttonComponent = (
                <OKButton {...props}>
                    {buttonText}
                </OKButton>
            );
        }

        return (
            <div className="payroll-loan-request-documents-buttons__finish-btn">
                <WebappRender>
                    {buttonComponent}
                </WebappRender>
                <ContactCenterRender>
                    {buttonComponent}
                </ContactCenterRender>
            </div>
        );
    }

    buildLeaveBtn() {
        const { handleLeaveBtn } = this.props;
        const buttonText = formatText("payrollLoanRequest-leaveButton");

        return (
            <div className="payroll-loan-request-documents-buttons__leave-btn">
                <OKButton
                    modifier="link-ghost"
                    onClick={handleLeaveBtn}
                >
                    {buttonText}
                </OKButton>
            </div>
        );
    }

    render() {
        const finisBtn = this.buildFinishBtn();
        const leaveBtn = this.buildLeaveBtn();

        return (
            <div className="payroll-loan-request-documents-buttons">
                {finisBtn}
                {leaveBtn}
            </div>
        );
    }
}

ContractPayrollLoanDocumentsButtons.propTypes = {
    finishButtonDisabled: PropTypes.bool,
    handleFinishBtn: PropTypes.func,
    handleLeaveBtn: PropTypes.func,
    loading: PropTypes.bool,
    recordStatus: PropTypes.string.isRequired
};

ContractPayrollLoanDocumentsButtons.defaultProps = {
    finishButtonDisabled: false,
};

module.exports = ContractPayrollLoanDocumentsButtons;
